var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.6699 11.5107C8.902 11.5107 5.03683 15.3759 5.03683 20.1438V40.6474C5.03683 43.0314 6.96941 44.964 9.35338 44.964C11.7373 44.964 13.6699 43.0314 13.6699 40.6474V11.5107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4668 37.4102C20.2347 37.4102 24.0999 33.545 24.0999 28.7771V8.27346C24.0999 5.8895 22.1673 3.95692 19.7833 3.95692C17.3994 3.95692 15.4668 5.8895 15.4668 8.27347V37.4102Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.3301 37.4102C41.098 37.4102 44.9632 33.545 44.9632 28.7771V8.27346C44.9632 5.8895 43.0306 3.95692 40.6466 3.95692C38.2627 3.95692 36.3301 5.8895 36.3301 8.27346V37.4102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M34.5332 19.0645H32.9433C29.0534 19.0645 25.9001 22.2178 25.9001 26.1076V41.7263C25.9001 44.1103 27.8327 46.0429 30.2167 46.0429C32.6006 46.0429 34.5332 44.1103 34.5332 41.7263V19.0645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIcon);
export default __webpack_public_path__ + "static/media/LoadIcon.1457d9ca5a8d865c99f0f72453940006.svg";
export { ForwardRef as ReactComponent };